import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import Header from '../components/Header';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';
import { isValidStoreCode } from '../config/stores';
import { useStores } from '../contexts/StoresContext';

function GoodPage() {
  const { language, setLanguage } = useLanguage();
  const { storeCode } = useParams<{ storeCode: string }>();
  const { isValid, get } = useStores();

  // Проверяем валидность кода магазина
  if (!storeCode || !isValid(storeCode)) return <Navigate to="/" replace />;

  const store = get(storeCode)!;

  return (
    <div className="App">
      <Header />
      <LanguageSwitcher language={language} setLanguage={setLanguage} />

      <main className="main-content">
        <img src="/good.png" className="mascot" alt="Qulpynai" />
        
        <h1 className="question">
          {language === 'ru' 
            ? 'Мы будем благодарны Вам, если Вы оставите свой положительный отзыв в 2GIS ' 
            : '2GIS жүйесінде өзіңіздің пікіріңізді қалдырсаңыз, біз риза боламыз '}
          <img src="/2gis.webp" alt="2GIS" className="gis-icon" />
        </h1>

        <div className="buttons">
          <a 
            href={`${store.address_2gis}/tab/reviews`}
            className="button primary"
            target="_blank"
            rel="noopener noreferrer"
          >
            {language === 'ru' ? 'Оставить отзыв' : 'Пікір қалдыру'}
          </a>
        </div>
      </main>
    </div>
  );
}

export default GoodPage; 